import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectMill } from "../actions/millActions";

import { withRouter } from "react-router-dom";

import Carousel from "./Carousel";
import ImageSkeleton from "./ImageSkeleton";

import { ReactComponent as Map } from "../icons/map_16px.svg";

const municipality = {
  Buende: "Bünde",
  Enger: "Enger",
  Herford: "Herford",
  Hiddenhausen: "Hiddenhausen",
  Kirchlengern: "Kirchlengern",
  Loehne: "Löhne",
  Roedinghausen: "Rödinghausen",
  Spenge: "Spenge",
  Vlotho: "Vlotho",
};
const propulsion = {
  1: "Wasser",
  2: "Motor",
  3: "Wind",
  4: "Dampf",
  5: "Muskelkraft",
  6: "Unbekannt",
};
const exists = {
  1: "ja",
  2: "nein",
  3: "teilweise",
};

class MultiCarousel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mills: props.mills.features,
      width: 0,
      index: 0,
    };
  }

  componentDidMount() {
    window.addEventListener("keydown", this.keyNavigation);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.progress && prevProps.inExtent !== this.props.inExtent) {
      this.setState({ mills: this.filterMillsByExtent() });
    }
    if (
      this.props.progress &&
      (prevProps.municipality !== this.props.municipality ||
        prevProps.propulsion !== this.props.propulsion ||
        prevProps.exists !== this.props.exists)
    ) {
      this.setState({ mills: this.filterMillsByAttributes() });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.keyNavigation);
  }

  keyNavigation = (event) => {
    if (this.props.theme === this.props.carousel) {
      if (this.props.selected.Objektnr) {
        if (event.key === "Escape" || event.keyCode === 27) {
          this.props.selectMill("");
        }
      }
    }
  };

  filterMillsByAttributes = () => {
    var filteredMills = this.props.mills.features;
    if (this.props.municipality.length > 0) {
      filteredMills = filteredMills.filter((mill) =>
        this.props.municipality.includes(mill.properties.Gemeinde)
      );
    }
    if (this.props.exists.length > 0) {
      filteredMills = filteredMills.filter((mill) =>
        this.props.exists.includes(mill.properties.GebäudeVorhanden)
      );
    }
    if (this.props.propulsion.length > 0) {
      filteredMills = filteredMills.filter((mill) =>
        this.props.propulsion.includes(mill.properties.Antriebsart)
      );
    }
    return filteredMills;
  };

  filterMillsByExtent = () => {
    var extentFeatures = this.props.mills.features.filter((feature) => {
      return this.props.inExtent.includes(feature.properties.Objektnr);
    });
    return extentFeatures;
  };

  select = (id) => {
    var mill = this.state.mills.filter(
      (mill) => mill.properties.Objektnr === id
    )[0];
    this.props.selectMill(mill.properties, "image");
  };

  showPdf = (id) => {
    var mill = this.state.mills.filter(
      (mill) => mill.properties.Objektnr === id
    )[0];
    this.props.selectMill(mill.properties);
  };

  getPropulsion(propulsionId) {
    switch (propulsionId) {
      case "1":
        return "Wasser";
      case "2":
        return "Motor";
      case "3":
        return "Wind";
      case "4":
        return "Dampf";
      case "5":
        return "Muskelkraft";
      case "6":
        return "Unbekannt";
      default:
        return "";
    }
  }

  renderMills = (millArray) => {
    return millArray.map((mill, i) => {
      const propulsion = this.getPropulsion(mill.properties.Antriebsart);
      return (
        <div key={i} style={{ padding: "1.25rem 0.5rem" }}>
          <div
            className={`item mill-item itemColor ${
              this.props.selected.Objektnr === mill.properties.Objektnr
                ? "select"
                : ""
            }`}
          >
            <div
              style={{ cursor: "pointer", height: "185px" }}
              onClick={() => {
                this.showPdf(mill.properties.Objektnr);
                this.props.history.push(
                  `/muehlenkataster/${mill.properties.Gemeinde.toLowerCase()}/${
                    mill.properties.Objektnr.split("_")[1]
                  }`
                );
              }}
              className={`${
                this.props.selected.Objektnr === mill.properties.Objektnr
                  ? ""
                  : "itemHover"
              }`}
            >
              <ImageSkeleton
                className={`item-picture`}
                classNameImg={"imageZoom"}
                src={
                  mill.properties.Thumb !== ""
                    ? `${process.env.REACT_APP_DOCUMENT_URL}/${mill.properties.Gemeinde}/${mill.properties.Objektnr}/thumb/${mill.properties.Thumb}`
                    : mill.properties.Bilder !== ""
                    ? `${process.env.REACT_APP_DOCUMENT_URL}/${
                        mill.properties.Gemeinde
                      }/${mill.properties.Objektnr}/bilder/${
                        mill.properties.Bilder.split(",")[0]
                      }`
                    : `${process.env.PUBLIC_URL}/${propulsion}.png`
                }
                width={"100%"}
                height={"125px"}
              />
              <div style={{ padding: "0 1.25rem" }}>
                <h3 className="item-title" title={mill.properties.Name}>
                  {mill.properties.Name}
                </h3>
                <div
                  style={{
                    marginTop: "-0.4rem",
                    color: "inherit",
                    width: "100%",
                    maxWidth: "max-content",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {`Antriebsart ${propulsion}`}
                </div>
              </div>
            </div>
            {this.props.progress ? null : (
              <div
                onClick={() => this.select(mill.properties.Objektnr)}
                style={{
                  padding: "0 1.25rem",
                  color: "inherit",
                  cursor: "help",
                  width: "calc(100% - 2.5rem)",
                  // maxWidth: "max-content",
                  height: "calc(220px - 185px)",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "flex",
                }}
                className={`mapShow ${
                  this.props.selected.Objektnr === mill.properties.Objektnr
                    ? ""
                    : "mapHover"
                }`}
              >
                <Map
                  style={{
                    marginRight: "5px",
                    marginTop: "4px",
                    // marginBottom: "auto",
                  }}
                />
                in Karte anzeigen
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  renderHiddenMills = (millArray) => {
    return millArray.map((mill, i) => {
      const propulsion = this.getPropulsion(mill.properties.Antriebsart);
      return (
        <div key={i} style={{ padding: "1.25rem 0.5rem" }}>
          <div
            className={`item ${
              this.props.selected.Objektnr === mill.properties.Objektnr
                ? "select"
                : "itemHover"
            }`}
          >
            <div
              style={{ cursor: "pointer", height: "185px" }}
              onClick={() => this.showPdf(mill.properties.Objektnr)}
              className={`${
                this.props.selected.Objektnr === mill.properties.Objektnr
                  ? ""
                  : "mapHover"
              }`}
            >
              <ImageSkeleton
                className={`item-picture`}
                classNameImg={"imageZoom"}
                src={
                  mill.properties.Thumb !== ""
                    ? `${process.env.REACT_APP_DOCUMENT_URL}/${mill.properties.Gemeinde}/${mill.properties.Objektnr}/thumb/${mill.properties.Thumb}`
                    : mill.properties.Bilder !== ""
                    ? `${process.env.REACT_APP_DOCUMENT_URL}/${
                        mill.properties.Gemeinde
                      }/${mill.properties.Objektnr}/bilder/${
                        mill.properties.Bilder.split(",")[0]
                      }`
                    : `${process.env.PUBLIC_URL}/${propulsion}.png`
                }
                width={"100%"}
                height={"125px"}
              />
              <div style={{ padding: "0 1.25rem" }}>
                <h3 className="item-title" title={mill.properties.Name}>
                  {mill.properties.Name}
                </h3>
                <div
                  style={{
                    marginTop: "-0.4rem",
                    color: "inherit",
                    width: "100%",
                    maxWidth: "max-content",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                  }}
                >
                  {`Antriebsart ${propulsion}`}
                </div>
              </div>
            </div>

            {this.props.progress ? null : (
              <div
                onClick={() => this.select(mill.properties.Objektnr)}
                style={{
                  padding: "0 1.25rem",
                  color: "inherit",
                  cursor: "help",
                  width: "calc(100% - 2.5rem)",
                  // maxWidth: "max-content",
                  height: "calc(220px - 185px)",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  display: "flex",
                }}
                className={`mapShow ${
                  this.props.selected.Objektnr === mill.properties.Objektnr
                    ? ""
                    : "mapHover"
                }`}
              >
                <Map
                  style={{
                    marginRight: "5px",
                    marginTop: "4px",
                    // marginBottom: "auto",
                  }}
                />
                in Karte anzeigen
              </div>
            )}
          </div>
        </div>
      );
    });
  };

  render() {
    var filterCount =
      this.props.municipality.length +
      this.props.propulsion.length +
      this.props.exists.length +
      this.props.time.length;
    return this.props.mills.features ? (
      <div className="mill-carousel" style={{ height: "262px" }}>
        {this.state.mills.length > 0 ? (
          <Carousel
            render={this.renderMills}
            renderHidden={this.renderHiddenMills}
            items={this.state.mills}
            isSelected={
              this.props.selected.art && this.props.selected.art === "map"
            }
            theme={"mills"}
          />
        ) : (
          <div
            style={{
              margin: "auto",
              width: "calc(100% - 2rem - 86px - 10px)",
              padding: "1.25rem 0.5rem",
              height: "calc(220px + 1.25rem + 1.25rem",
            }}
          >
            {filterCount > 0
              ? `Es sind keine Mühlen mit ${
                  filterCount > 1
                    ? "den angegebenen Filtern"
                    : "dem angegebenem Filter"
                } (${`${
                  this.props.municipality.length > 0
                    ? `; Gemeinde: ${this.props.municipality
                        .map((m) => municipality[m])
                        .join(", ")}`
                    : ""
                }${
                  this.props.propulsion.length > 0
                    ? `; Antriebsart: ${this.props.propulsion
                        .map((p) => propulsion[p])
                        .join(", ")}`
                    : ""
                }${
                  this.props.exists.length > 0
                    ? `; Gebäude vorhanden: ${this.props.exists
                        .map((e) => exists[e])
                        .join(", ")}`
                    : ""
                }${
                  this.props.time.length > 0
                    ? `; Zeit: ${this.props.time.join(", ")}`
                    : ""
                }`.replace(
                  "; ",
                  ""
                )}) in dem gewählten Kartenausschnitt verfügbar.`
              : "Es sind keine Mühlen in dem gewählten Kartenausschnitt verfügbar."}
          </div>
        )}
      </div>
    ) : null;
  }
}

MultiCarousel.propTypes = {
  mills: PropTypes.object.isRequired,
  selectMill: PropTypes.func.isRequired,
  inExtent: PropTypes.array,
  selected: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  municipality: PropTypes.array.isRequired,
  propulsion: PropTypes.array.isRequired,
  exists: PropTypes.array.isRequired,
  time: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  mills: state.mill.mills,
  selected: state.mill.selected,
  inExtent: state.mill.inExtent,
  progress: state.mill.progressMap,
  municipality: state.mill.filter.municipality,
  propulsion: state.mill.filter.propulsion,
  exists: state.mill.filter.exists,
  time: state.mill.filter.time,
});

export default connect(mapStateToProps, { selectMill })(
  withRouter(MultiCarousel)
);
